import { Eye, Users } from "lucide-react"
import { useNavigate } from "react-router-dom";
import { ROUTE_PATHS } from "../../../constants/routeConstants";

export const RecentPatientTable = ({ recentPatients, isLoadingPatients }) => {
    const navigate = useNavigate();
    return <> <div className="flex items-center justify-between mb-4">
        <div>
            <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-slate-400 dark:text-slate-500">Newly Registered</p>
            <h2 className="mt-1 text-lg font-bold text-slate-900 dark:text-white">Recent Patients</h2>
        </div>
        <div className="inline-flex items-center gap-1.5 rounded-xl bg-emerald-50 px-2.5 py-1 text-xs font-bold text-emerald-700 dark:bg-emerald-950/30 dark:text-emerald-400">
            <Users className="h-3.5 w-3.5" />
            {recentPatients?.length || 0} Total
        </div>
    </div>

        {/* Scroll Container with Professional Compact Height */}
        <div className="overflow-y-auto max-h-[380px] rounded-2xl border border-slate-100 dark:border-slate-800 custom-scrollbar">
            <table className="min-w-full table-auto border-collapse text-left">
                <thead className="sticky top-0 z-10 bg-slate-50/90 text-[10px] font-bold uppercase tracking-wider text-slate-500 backdrop-blur-sm dark:bg-slate-900/90 dark:text-slate-400">
                    <tr className="border-b border-slate-100 dark:border-slate-800">
                        <th className="px-4 py-2.5">System No</th>
                        <th className="px-4 py-2.5">Patient Details</th>
                        <th className="px-4 py-2.5">Reg Date</th>
                        <th className="px-4 py-2.5">Physician</th>
                        <th className="px-4 py-2.5 text-center">Action</th>
                    </tr>
                </thead>
                <tbody className="divide-y divide-slate-100 bg-white dark:divide-slate-800/60 dark:bg-slate-950">
                    {isLoadingPatients ? (
                        // Agar data fetch ho raha hai, toh 5 dummy rows ka skeleton dikhao
                        Array.from({ length: 5 }).map((_, idx) => (
                            <tr key={`skeleton-${idx}`} className="animate-pulse">
                                <td className="px-4 py-3">
                                    <div className="h-4 w-12 rounded bg-slate-200 dark:bg-slate-800" />
                                </td>
                                <td className="px-4 py-3">
                                    <div className="flex flex-col gap-1.5">
                                        <div className="h-4 w-32 rounded bg-slate-200 dark:bg-slate-800" />
                                        <div className="h-3 w-20 rounded bg-slate-100 dark:bg-slate-900" />
                                    </div>
                                </td>
                                <td className="px-4 py-3">
                                    <div className="h-4 w-16 rounded bg-slate-200 dark:bg-slate-800" />
                                </td>
                                <td className="px-4 py-3">
                                    <div className="h-4 w-24 rounded bg-slate-200 dark:bg-slate-800" />
                                </td>
                                <td className="px-4 py-3 text-center">
                                    <div className="mx-auto h-7 w-16 rounded-lg bg-slate-200 dark:bg-slate-800" />
                                </td>
                            </tr>
                        ))
                    ) : recentPatients && recentPatients.length > 0 ? (
                        recentPatients.map((item, index) => (
                            <tr key={item.system_number || index} className="group transition hover:bg-slate-50/80 dark:hover:bg-slate-900/40">
                                {/* System Number */}
                                <td className="px-4 py-2.5 text-xs font-semibold text-slate-600 dark:text-slate-400">
                                    #{item.system_number}
                                </td>
                                {/* Patient Name & F/H Name Combo */}
                                <td className="px-4 py-2.5">
                                    <div className="flex flex-col">
                                        <span className="text-xs font-bold text-slate-800 dark:text-slate-200">{item.patient_name}</span>
                                        <span className="text-[10px] text-slate-400 dark:text-slate-500">S/O, W/O: {item.father_husband_name || 'N/A'}</span>
                                    </div>
                                </td>
                                {/* Registration Date */}
                                <td className="px-4 py-2.5 text-xs text-slate-600 dark:text-slate-400">
                                    {item.reg_date ? new Date(item.reg_date).toLocaleDateString() : 'N/A'}
                                </td>
                                {/* Physician Associated */}
                                <td className="px-4 py-2.5">
                                    <span className="inline-flex items-center text-xs font-medium text-slate-700 dark:text-slate-300">
                                        {item.physician?.name || 'Unassigned'}
                                    </span>
                                </td>
                                {/* Actions */}
                                <td className="px-4 py-2.5 text-center">
                                    <button onClick={() => {
                                        navigate(ROUTE_PATHS.PATIENT_DETAILS.replace(":system_number", item.system_number),
                                            {
                                                state: { patient_details: item },
                                            }
                                        )
                                    }} className="inline-flex h-7 items-center gap-1 rounded-lg bg-slate-900 px-2.5 text-xs font-semibold text-white transition hover:bg-slate-800 dark:bg-slate-800 dark:text-slate-200 dark:hover:bg-slate-700">
                                        <Eye className="h-3 w-3" /> View
                                    </button>
                                </td>
                            </tr>
                        ))
                    ) : (
                        // Fallback: Agar data fetch ho jaye par list khali ho (Empty State)
                        <tr>
                            <td colSpan={5} className="px-4 py-8 text-center text-xs font-medium text-slate-400 dark:text-slate-500">
                                No recent patients found.
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div></>
}